export const useLetsFindYourFloor = (banners = []) => {
  return banners.map((item, index) => ({
    id: item.id || index + 1,
    src: item.media,
    className: `imgf${index + 1}`,
  }));
};